import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown, FileText } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { PageHeader, FullLoader, EmptyState } from "../components/common";

const backend = process.env.REACT_APP_BACKEND_URL;

export default function Statements() {
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/statements")
      .then((r) => setStatements(r.data.statements))
      .catch((e) => toast.error(errMsg(e)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <FullLoader />;

  return (
    <div className="animate-fade-up" data-testid="statements-page">
      <PageHeader title="Account statements" subtitle="Download a PDF statement for any month" />

      {statements.length === 0 ? (
        <EmptyState icon={FileText} title="No statements yet"
          body="Once you have transactions, a monthly PDF statement will appear here for you to download." />
      ) : (
        <div className="rounded-3xl bg-card border border-border divide-y divide-border overflow-hidden">
          {statements.map((s) => (
            <a key={s.ym} href={`${backend}/api/statements/${s.ym}`} target="_blank" rel="noopener noreferrer"
              data-testid={`statement-${s.ym}`}
              className="flex items-center gap-3 p-4 transition-colors hover:bg-secondary/50 active:bg-secondary">
              <span className="grid place-items-center w-11 h-11 rounded-2xl bg-primary/10 text-primary shrink-0"><FileText size={20} /></span>
              <div className="flex-1 min-w-0">
                <div className="font-semibold">{s.label}</div>
                <div className="text-xs text-muted-foreground">Jack Cash account statement · PDF</div>
              </div>
              <span className="flex items-center gap-1.5 text-sm font-semibold text-primary"><FileDown size={16} /> Download</span>
            </a>
          ))}
        </div>
      )}

      <p className="text-[11px] text-muted-foreground text-center mt-4">
        Statements include your name, Cash Tag and saved address. Add your address in Profile → Home address.
      </p>
    </div>
  );
}
